
<template lang="pug">
input.cnmn-file-input(
  type="file"
  :accept="accept"
  @blur="blur"
  @change="change"
)
</template>

<script>
import bytes from 'bytes'

export default {
  props: {
    value:   {type: Object, required: true},
    accept:  String,
    maxSize: {type: [Number, String], default: '1MB'},
  },

  computed: {
    maxSizeNumber() {
      return bytes.parse(this.maxSize)
    },

    maxSizeFormat() {
      return bytes.format(this.maxSizeNumber)
    },
  },

  methods: {
    blur(el) {
      this.$emit('blur', el)
    },

    change(el) {
      const file = el.target.files[0]

      if(this.maxSizeNumber < file.size) {
        this.$cnmn.notify.error('ファイルサイズが大きすぎます(最大' + this.maxSizeFormat + 'バイト)')
        this.$emit('input', {})
        el.target.value = ''
        return
      }

      const reader = new FileReader
      reader.onload = ev => {
        this.$emit('input', {
          filesize: file.size,
          filename: file.name,
          file: ev.target.result,
        })
      }
      reader.readAsDataURL(file)
    },

    click() {
      this.$el.click()
    },
  },
}
</script>
